export default __webpack_public_path__ + "static/floating_video-aa673abf2631f6e73b08a9952c87153d.png";